module.exports = __webpack_public_path__ + "img/about.b9c0d6e8.png";